import { Xdp, XdpServerResponse } from './xdp.types';

export function adaptToCreate(
  xdpData: Xdp,
): Xdp {
  return xdpData;
}

export function adaptXdpList(
  xdpList: Xdp[] | XdpServerResponse[],
): Xdp[] {
  return xdpList.map(adaptFromServerFormat);
}

export function adaptSelectedXdp(
  xdpList: Xdp[] | XdpServerResponse[],
): Xdp[] {
  return xdpList.map(adaptFromServerFormat);
}

export function adaptFromServerFormat(
  xdpData: Xdp | XdpServerResponse,
): Xdp {

  const insideNat: boolean = (xdpData as XdpServerResponse).INSIDENAT === 'YES' || (xdpData as Xdp).insideNat === 'YES';

  return {
    id: xdpData.id,
    inPortEnd: (xdpData as XdpServerResponse).INPORTEND || (xdpData as Xdp).inPortEnd,
    inPortStart: (xdpData as XdpServerResponse).INPORTSTART || (xdpData as Xdp).inPortStart,
    insideNat,
    ipAddr: (xdpData as XdpServerResponse).IPADDR || (xdpData as Xdp).ipAddr,
    ipduId: (xdpData as XdpServerResponse).IPDUID || (xdpData as Xdp).ipduId,
    outPortEnd: (xdpData as XdpServerResponse).OUTPORTEND || (xdpData as Xdp).outPortEnd,
    outPortStart: (xdpData as XdpServerResponse).OUTPORTSTART || (xdpData as Xdp).outPortStart,
    port: (xdpData as XdpServerResponse).PORT || (xdpData as Xdp).port,
    state: (xdpData as XdpServerResponse).STATE || (xdpData as Xdp).state,
    switchTech: (xdpData as XdpServerResponse).SWITCHTECH || (xdpData as Xdp).switchTech,
    nodeName: (xdpData as XdpServerResponse).NODENAME || (xdpData as Xdp).nodeName,
    access: (xdpData as XdpServerResponse).ACCESS || (xdpData as Xdp).access,
    group: (xdpData as XdpServerResponse).GROUP || (xdpData as Xdp).group,
    listenip: (xdpData as XdpServerResponse).LISTENIP || (xdpData as Xdp).listenip,
    owner: (xdpData as XdpServerResponse).OWNER || (xdpData as Xdp).owner,
  };
}

export function adaptToServerFormat(
  xdpData: Xdp,
): XdpServerResponse {

  return {
    id: xdpData.id,
    INPORTEND: xdpData.inPortEnd,
    INPORTSTART: xdpData.inPortStart,
    INSIDENAT: xdpData.insideNat === true ? 'YES' : 'NO',
    IPADDR: xdpData.ipAddr,
    IPDUID: xdpData.ipduId,
    OUTPORTEND: xdpData.outPortEnd,
    OUTPORTSTART: xdpData.outPortStart,
    PORT: xdpData.port,
    LISTENIP: xdpData.listenip,
    STATE: xdpData.state,
    SWITCHTECH: xdpData.switchTech,
    NODENAME: xdpData.nodeName,
    ACCESS: xdpData.access,
    GROUP: xdpData.group,
  };
}
